import { render, staticRenderFns } from "./ChatBotCommands.vue?vue&type=template&id=d5cba9a8"
import script from "./ChatBotCommands.vue?vue&type=script&lang=js"
export * from "./ChatBotCommands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports